export default __webpack_public_path__ + "slices/main/assets/public/media/logo-bar-warby-parker@2x.b2085150d883ebc1fcf532a560ef83a7.png";